import Loading from '../../../shared/Loading/Loading';
import ButtonLoadingContent from '../../../shared/Loading/ButtonLoadingContent';
import AsyncButton from '../../../shared/Loading/AsyncButton';

const MONTHS = [
    'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
    'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre',
];

const InteractionSelection = (props) => {
    const interactions = props.interactions || [];
    const prize = props.prize;
    const totalScore = Number(props.totalScore || 0);
    const userScore = Number(props.userScore || 0);
    const getQuantity = (interaction) => Number(props.quantities?.[interaction.id] || 0);
    const selectedInteractions = interactions.filter((interaction) => getQuantity(interaction) > 0);

    const now = new Date();
    const fechaCanje = `${MONTHS[now.getMonth()]} ${String(now.getDate()).padStart(2, '0')} ${now.getFullYear()} ${String(now.getHours()).padStart(2, '0')}:${String(now.getMinutes()).padStart(2, '0')}`;
    const email = props.user?.PrincipalEmail || '-';

    return (
        <div className="exchange-view max-w-7xl mx-auto px-6 pt-2 pb-2 -mb-8">
            <div className="flex items-center justify-between mb-6">
                <h2 className="text-2xl font-semibold">Canjea tus puntos</h2>
                <AsyncButton
                    onClick={props.onBack}
                    className="md:hidden px-4 py-2 border border-personalized bg-personalized text-white rounded flex items-center gap-2 hover:bg-white hover:text-personalized"
                >
                    <span>←</span>
                    Volver
                </AsyncButton>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-[1fr_350px] gap-8">
                {/* Columna izquierda: Paso 3 - Confirmación */}
                <div className="space-y-6">
                    <div className="rounded-lg border border-gray-200 bg-white p-4 shadow-sm">
                        <h3 className="text-lg font-semibold mb-4 flex items-center gap-2">
                            <span className="inline-flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-personalized text-sm font-semibold text-white">3</span>
                            Confirma tu canje
                        </h3>

                        <h4 className="mb-3 text-sm font-semibold text-gray-700">Interacciones seleccionadas</h4>

                        {props.loading && (
                            <div className="flex justify-center rounded-lg border border-gray-200 bg-gray-50 p-6">
                                <Loading size="6" colorBase="white" colorAccent="personalized" double bold="4" />
                            </div>
                        )}

                        {!props.loading && selectedInteractions.length === 0 && (
                            <div className="rounded-lg border border-gray-200 bg-gray-50 p-4 text-sm text-gray-500">
                                No hay interacciones seleccionadas.
                            </div>
                        )}

                        {!props.loading && selectedInteractions.map((interaction) => (
                            <div
                                key={interaction.id}
                                className="mb-2 rounded-lg border border-gray-200 bg-white p-3 shadow-sm"
                            >
                                <div className="grid grid-cols-1 gap-3 sm:grid-cols-[minmax(0,1fr)_auto] sm:items-center">
                                    <div className="min-w-0">
                                        <p className="font-semibold text-gray-900 break-words">
                                            {interaction.interaction}
                                        </p>
                                        <p className="mt-1 text-sm text-gray-500">
                                            Cantidad: {getQuantity(interaction)}
                                        </p>
                                        <p className="mt-1 text-sm font-medium text-green-700">
                                            Valor unitario: {interaction.value} puntos
                                        </p>
                                    </div>
                                    <div className="text-right">
                                        <p className="text-sm text-gray-600">Total:</p>
                                        <p className="text-lg font-bold text-personalized">{getQuantity(interaction) * interaction.value}</p>
                                    </div>
                                </div>
                            </div>
                        ))}

                        <div className="mt-6 border-t border-gray-200 pt-4">
                            <h4 className="mb-4 text-sm font-semibold text-gray-700">Información del canje</h4>

                            <div className="mb-3">
                                <label className="block text-sm font-semibold text-gray-700 mb-1">Nombre y Apellidos</label>
                                <input
                                    type="text"
                                    disabled
                                    value={`${props.user?.FirstName ?? ''} ${props.user?.LastName ?? ''}`.trim() || '-'}
                                    className="w-full rounded border border-gray-200 bg-gray-50 px-3 py-2 text-sm text-gray-700 disabled:cursor-not-allowed"
                                />
                            </div>

                            <div className="mb-3">
                                <label className="block text-sm font-semibold text-gray-700 mb-1">Correo electrónico</label>
                                <input
                                    type="email"
                                    disabled
                                    value={email}
                                    className="w-full rounded border border-gray-200 bg-gray-50 px-3 py-2 text-sm text-gray-700 disabled:cursor-not-allowed"
                                />
                            </div>

                            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                                <div>
                                    <label className="block text-sm font-semibold text-gray-700 mb-1">País</label>
                                    <input
                                        type="text"
                                        disabled
                                        value={props.country || '-'}
                                        className="w-full rounded border border-gray-200 bg-gray-50 px-3 py-2 text-sm text-gray-700 disabled:cursor-not-allowed"
                                    />
                                </div>
                                <div>
                                    <label className="block text-sm font-semibold text-gray-700 mb-1">Ciudad</label>
                                    <input
                                        type="text"
                                        disabled
                                        value={props.user?.CityName || '-'}
                                        className="w-full rounded border border-gray-200 bg-gray-50 px-3 py-2 text-sm text-gray-700 disabled:cursor-not-allowed"
                                    />
                                </div>
                            </div>
                        </div>

                        <div className="mt-6 border-t border-gray-200 pt-4">
                            <label className="mb-3 flex items-start gap-2 text-sm text-gray-700 cursor-pointer">
                                <input
                                    type="checkbox"
                                    checked={!!props.aceptarTerminos}
                                    onChange={(e) => props.onToggleTerms?.(e.target.checked)}
                                    style={{ accentColor: '#7e10be' }}
                                    className="mt-0.5 h-4 w-4 shrink-0 cursor-pointer"
                                />
                                <span>
                                    Aceptar los{' '}
                                    <AsyncButton
                                        type="button"
                                        light
                                        spinnerSize="4"
                                        onClick={props.onViewTerms}
                                        className="font-medium text-personalized underline hover:opacity-80"
                                    >
                                        Términos y condiciones
                                    </AsyncButton>{' '}
                                    del programa de puntos.
                                </span>
                            </label>

                            <div className="exchange-info-message rounded-lg border border-purple-200 bg-purple-50 p-3 flex gap-3">
                                <div className="flex-shrink-0 pt-0.5">
                                    <svg className="w-5 h-5 text-purple-600" fill="currentColor" viewBox="0 0 20 20">
                                        <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
                                    </svg>
                                </div>
                                <p className="text-xs text-purple-800">
                                    Al confirmar el canje, se enviará a tu correo electrónico un comprobante. Es de uso personal e intransferible.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Columna derecha: Card de Resumen */}
                <div className="exchange-resumen-col">
                    <AsyncButton
                        onClick={props.onBack}
                        className="exchange-back-btn hidden md:flex px-4 py-2 border border-personalized bg-personalized text-white rounded items-center gap-2 hover:bg-white hover:text-personalized"
                    >
                        <span>←</span>
                        Volver
                    </AsyncButton>
                    <div className="rounded-lg border border-gray-200 bg-white p-4 shadow-sm">
                        <h3 className="text-lg font-semibold mb-4 text-gray-900">Resumen de tu canje</h3>

                        <div className="space-y-2 mb-4 pb-4 border-b border-gray-200">
                            <div className="flex justify-between items-center">
                                <p className="text-sm text-gray-700">Tus Puntos disponibles</p>
                                <p className="text-lg font-bold text-personalized">{userScore}</p>
                            </div>
                            <div className="flex justify-between items-center">
                                <p className="text-sm text-gray-700">Usarás</p>
                                <p className="text-lg font-bold text-gray-900">{totalScore}</p>
                            </div>
                            <div className="flex justify-between items-center">
                                <p className="text-sm text-gray-700">Te quedarán</p>
                                <p className="text-lg font-bold text-gray-900">{Math.max(userScore - totalScore, 0)}</p>
                            </div>
                        </div>

                        {prize && (
                            <div className="rounded bg-blue-50 p-3 mb-4">
                                <p className="text-xs text-gray-600 font-medium">Premio seleccionado</p>
                                <p className="text-sm font-semibold text-gray-900 mt-1 break-words">{prize.title}</p>
                                {prize.visibleScore && (
                                    <p className="text-xs text-green-700 font-medium mt-2">
                                        Valor: {prize.prize} puntos
                                    </p>
                                )}
                            </div>
                        )}

                        {props.leftoverScore > 0 && (
                            <div className="rounded border border-yellow-200 bg-yellow-50 p-3 mb-4">
                                <p className="text-sm font-semibold text-yellow-800">
                                    Este canje usará {totalScore} puntos. Los {props.leftoverScore} puntos restantes no se conservan.
                                </p>
                            </div>
                        )}

                        <button
                            type="button"
                            onClick={props.onFinish}
                            disabled={props.assigningBondaCurrency || !props.aceptarTerminos}
                            className={`w-full px-4 py-2 rounded border text-white font-medium ${
                                props.assigningBondaCurrency || !props.aceptarTerminos
                                    ? 'border-gray-300 bg-gray-300 cursor-not-allowed'
                                    : 'border-personalized bg-personalized hover:bg-white hover:text-personalized'
                            }`}
                        >
                            <ButtonLoadingContent loading={props.assigningBondaCurrency}>
                                Confirmar y completar canje
                            </ButtonLoadingContent>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default InteractionSelection;
